{
  "en": {
    "title": {
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Home",
      "ships": {
        "index": "Ships",
        "viewer": "Ship Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Images",
      "shipVideos": "%{name} Videos",
      "shipHistory": "%{name} History",
      "componentHistory": "%{name} History",
      "shipViewer": "%{name} Viewer",
      "images": "Images",
      "stats": "Stats",
      "login": "Login",
      "signUp": "Sign Up",
      "embed": "Embed Widget",
      "apiV1": "API V1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Pagination",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "hangar": {
        "index": "My Hangar",
        "preview": "My Hangar Preview",
        "stats": "My Hangar Stats",
        "import": "Import",
        "public": "%{user} Hangar",
        "publicStats": "%{user} Hangar Stats",
        "wishlist": "Wishlist",
        "publicWishlist": "%{user} Wishlist",
        "vehicleLoadouts": "Vehicle Loadouts",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "Vehicle Cargo",
        "imports": "Imports",
        "transfers": "Transfers"
      },
      "requestPassword": "Request Password",
      "changePassword": "Change Password",
      "fleets": {
        "add": "Create a new Fleet",
        "preview": "Fleet Preview",
        "invites": "Fleet Invites",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "%{fleet} Member Worldmap",
          "starmap": "%{fleet} Member Starmap"
        },
        "stats": "%{fleet} Stats",
        "blueprints": "%{fleet} Blueprints",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories",
          "transfers": "%{fleet} Transfers"
        },
        "missions": {
          "index": "%{fleet} Missions",
          "create": "Create Mission - %{fleet}",
          "edit": {
            "details": "Edit Mission - %{fleet}",
            "teams": "Edit Teams & Slots - %{fleet}"
          },
          "show": "%{fleet} Mission"
        },
        "events": {
          "index": "%{fleet} Events",
          "calendar": "%{fleet} Calendar",
          "create": "Create Event - %{fleet}",
          "edit": {
            "details": "Edit Event - %{fleet}",
            "schedule": "Edit Schedule - %{fleet}",
            "signup": "Edit Sign-up - %{fleet}",
            "teams": "Edit Teams & Slots - %{fleet}"
          },
          "show": "%{fleet} Event",
          "payouts": "%{fleet} Event Payouts"
        },
        "tours": {
          "index": "%{fleet} Tours",
          "create": "Create Tour - %{fleet}",
          "show": "%{fleet} Tour"
        },
        "settings": {
          "index": "%{fleet} Settings",
          "fleet": "%{fleet} Settings",
          "membership": "%{fleet} Membership",
          "roles": "%{fleet} Roles",
          "notifications": "%{fleet} Notification Settings",
          "discord": "%{fleet} Discord Settings",
          "calendar": "%{fleet} Calendar Settings",
          "features": "%{fleet} Features",
          "contracts": "%{fleet} Contract Settings"
        },
        "contracts": {
          "index": "Contracts",
          "create": "Create Contract",
          "edit": "Edit Contract",
          "show": "Contract"
        }
      },
      "roadmap": {
        "index": "Roadmap",
        "ships": "Ship-Roadmap",
        "changes": "Roadmap Changes"
      },
      "settings": {
        "index": "Profile Settings",
        "profile": "Profile Settings",
        "account": "Account",
        "hangar": "Hangar Settings",
        "privacy": "Privacy Settings",
        "features": "Feature Flags",
        "connections": "Connections",
        "oauthApplications": "OAuth Applications",
        "notifications": "Notification Settings",
        "calendar": "Calendar Subscription",
        "donations": "Donations",
        "security": "Account Security",
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "friends": "Friends"
      },
      "compare": {
        "ships": "Compare Ships"
      },
      "notFound": "404",
      "tools": {
        "index": "Tools",
        "travelTimes": "Travel Times",
        "cargoGrids": "Cargo Grids",
        "tours": {
          "index": "Tours",
          "add": "Create a new Tour",
          "show": "%{tour}",
          "join": "Join Tour"
        }
      },
      "impressum": "Impressum",
      "support": "Support",
      "privacyPolicy": "Privacy policy",
      "cookiePolicy": "Cookie policy",
      "visualTests": {
        "blueprints": "Blueprints",
        "index": "Visual Tests",
        "panels": "Panels - Visual Tests",
        "buttons": "Buttons - Visual Tests",
        "events": "Events",
        "typography": "Typography - Visual Tests",
        "forms": "Forms - Visual Tests",
        "tables": "Tables - Visual Tests",
        "lists": "Lists - Visual Tests",
        "metrics": "Metrics - Visual Tests",
        "states": "States - Visual Tests",
        "notifications": "Notifications - Visual Tests",
        "syncModal": "Sync Modal - Visual Tests",
        "overlays": "Overlays - Visual Tests",
        "supportHint": "Support Hint - Visual Tests",
        "media": "Media - Visual Tests",
        "charts": "Charts - Visual Tests",
        "chips": "Chips - Visual Tests",
        "notificationCenter": "Notification Center - Visual Tests"
      },
      "admin": {
        "blueprints": {
          "index": "Blueprints",
          "show": "%{blueprint}"
        },
        "models": {
          "index": "Models",
          "new": "New Model",
          "edit": {
            "index": "Edit %{manufacturer} %{model}",
            "metrics": "Edit %{manufacturer} %{model} Metrics",
            "prices": "Edit %{manufacturer} %{model} Prices",
            "fleetchart": "Edit %{manufacturer} %{model} Fleetchart Images",
            "positions": "Edit %{manufacturer} %{model} Positions",
            "hardpoints": "Edit %{manufacturer} %{model} Hardpoints",
            "cargoAndFuel": "Edit %{manufacturer} %{model} Fuel",
            "cargoHolds": "Edit %{manufacturer} %{model} Cargo Holds",
            "docks": "Edit %{manufacturer} %{model} Docks",
            "modules": "Edit %{manufacturer} %{model} Modules",
            "paints": "Edit %{manufacturer} %{model} Paints",
            "images": "Edit %{manufacturer} %{model} Images",
            "videos": "Edit %{manufacturer} %{model} Videos",
            "loaners": "Edit %{manufacturer} %{model} Loaners",
            "snubCrafts": "Edit %{manufacturer} %{model} Snub Crafts",
            "upgrades": "Edit %{manufacturer} %{model} Upgrades",
            "packages": "Edit %{manufacturer} %{model} Packages",
            "history": "Edit %{manufacturer} %{model} History"
          }
        },
        "components": {
          "index": "Components",
          "new": "New Component",
          "edit": {
            "index": "Edit Component",
            "prices": "Edit Component Prices",
            "history": "Edit Component History"
          }
        },
        "manufacturers": {
          "index": "Manufacturers",
          "new": "New Manufacturer",
          "edit": {
            "index": "Edit Manufacturer"
          }
        },
        "announcements": {
          "index": "Announcements",
          "new": "New Announcement",
          "edit": "Edit Announcement"
        },
        "supporterContributions": {
          "index": "Supporter Contributions",
          "new": "New Supporter Contribution",
          "edit": "Edit Supporter Contribution"
        },
        "fundingGoals": {
          "index": "Funding Goals",
          "new": "New Funding Goal",
          "edit": "Edit Funding Goal"
        },
        "users": {
          "index": "Users",
          "edit": "Edit User",
          "inventories": "User Inventories",
          "inventory": "User Inventory",
          "inventoryItem": "Inventory Entry",
          "fleets": "User Fleets",
          "supporterContributions": "User Supporter Contributions"
        },
        "vehicles": {
          "index": "Vehicles",
          "edit": "Edit Vehicle"
        },
        "admins": {
          "index": "Admins",
          "new": "New Admin",
          "edit": "Edit Admin"
        },
        "fleets": {
          "index": "Fleets",
          "edit": "Edit Fleet",
          "members": "Fleet Members",
          "memberEdit": "Edit Fleet Member",
          "history": "Fleet History",
          "roles": "Fleet Roles",
          "role": "Fleet Role",
          "inventories": "Fleet Inventories",
          "inventory": "Fleet Inventory",
          "inventoryItem": "Inventory Entry"
        },
        "oauthApplications": {
          "index": "OAuth Applications",
          "new": "New OAuth Application",
          "edit": "Edit OAuth Application"
        },
        "features": {
          "index": "Feature Flags",
          "show": "Feature Details"
        },
        "images": {
          "index": "Images"
        },
        "notifications": {
          "index": "Notifications"
        },
        "maintenance": {
          "index": "Maintenance",
          "pghero": "PgHero",
          "features": "Features",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Tasks",
          "imports": "Imports",
          "importDetail": "Import Detail",
          "rsiApiStatus": "RSI API Status",
          "buildCompare": "Build Compare"
        },
        "modelPaints": {
          "index": "Model Paints",
          "edit": "Edit Model Paint"
        },
        "modelModules": {
          "index": "Model Modules",
          "edit": {
            "index": "Edit %{name} Base Data",
            "models": "Edit %{name} Models",
            "prices": "Edit %{name} Prices",
            "hardpoints": "Edit %{name} Hardpoints",
            "docks": "Edit %{name} Docks",
            "cargoHolds": "Edit %{name} Cargo Holds",
            "history": "Edit Module History"
          }
        },
        "unlistedModels": {
          "index": "Unlisted Ships"
        },
        "modelModulePackages": {
          "index": "Model Module Packages"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Visual Tests",
          "notifications": "Notifications - Visual Tests"
        }
      },
      "notifications": "Notifications",
      "component": "%{name}",
      "components": {
        "index": "Components"
      },
      "blueprints": {
        "index": "Blueprints"
      }
    }
  }
}
